import { render } from "./Error.vue?vue&type=template&id=5815b4be&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=5815b4be&scoped=true&lang=css"

import exportComponent from "D:\\project\\weshow-front-rococo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5815b4be"]])

export default __exports__